import React from "react";
import {GlobalContext} from "../../GlobalContext";
import {
    Button, Card,
    Col,
    Container, Form,
    FormCheck,
    FormControl, FormGroup, FormLabel, InputGroup,
    ListGroup,
    Modal,
    ModalBody,
    ModalDialog,
    ModalFooter,
    Row
} from "react-bootstrap";
import {PatientListRow} from "./PatientListRow";
import {PatientSearch} from "../common/patient/PatientSearch";
import Cookies from "universal-cookie";
import ModalHeader from "react-bootstrap/ModalHeader";
import {Glyph} from "../common/Glyph";
import {OptionalSelect} from "../common/OptionalSelect";
import moment from "moment-timezone";
import {shortDatePattern} from "../../utils/Dates";
import CalendarButton from "../common/CalendarButton";

export class SuperbillHome extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);

        this.state = {
            patients: [],
            myPatients: false,
            patientId: null,
            locations: [],
            locationId: "",
            arrived: true,
            unsubmittedOnly: false,
            submittedOnly: false,
            showFilterModal: false,
            internalProviders: [],
            selectedProviderIds: [],
            apptDate: null
        }
    }

    refreshTimer = null;

    componentDidMount() {
        const cookies = new Cookies();
        let settings = {myPatients: false, locationId: ""};
        try {
            let settingsCookie = cookies.get("sb-settings");
            if (settingsCookie && this.context.userProfile.userId == settingsCookie.userId) {
                settings = settingsCookie;
                // in case it was someone else's cookie, validate settings
                if (!this.context.userProfile.providerId) {
                    settings.myPatients = false;
                    settings.unsubmittedOnly = false;
                }
                if (settings.apptDate) settings.apptDate = moment(settings.apptDate).toDate();
            } else {
                // defaults
                settings = {
                    myPatients: this.context.userProfile.providerId ? true : false,
                    arrived: true,
                    unsubmittedOnly: this.context.userProfile.providerId ? true : false,
                    submittedOnly: false
                };
                this.saveSettings();
            }
        } catch(err) {
            console.error(`Error while parsing superbill settings from cookie: ${err}`);
        }
        this.setState({...settings}, this.loadPatients);
    }

    componentWillUnmount() {
        if (this.refreshTimer) window.clearTimeout(this.refreshTimer);
    }

    saveSettings = () => {
        const cookies = new Cookies();
        let settings = {
            userId: this.context.userProfile.userId,
            myPatients: this.state.myPatients,
            locationId: this.state.locationId,
            arrived: this.state.arrived,
            unsubmittedOnly: this.state.unsubmittedOnly,
            submittedOnly: this.state.submittedOnly,
            selectedProviderIds: this.state.selectedProviderIds,
            apptDate: this.state.apptDate ? moment(this.state.apptDate).format("YYYY-MM-DD") : null
        };
        cookies.set("sb-settings", JSON.stringify(settings), {path: "/"});
    }

    loadPatients = () => {
        if (this.refreshTimer) window.clearTimeout(this.refreshTimer);

        let submittedOnly = true;
        if (this.context.hasAnyRole(["System Admin", "Superbill Editor"])) submittedOnly = this.state.submittedOnly || false;

        this.context.apiRequest("GET", `/superbill/todaysPatients?submittedOnly=${submittedOnly}${
                this.context.userProfile.providerId && this.state.myPatients ? `&providerIds=${this.context.userProfile.providerId || ''}` : (this.state.selectedProviderIds.length > 0 ? `&providerIds=${encodeURIComponent(this.state.selectedProviderIds.join(','))}` : ``)}${
                this.state.patientId ? `&patientId=${this.state.patientId}` : ''}${
                this.state.locationId ? `&locationId=${this.state.locationId}` : ``}&arrived=${this.state.arrived}&unsubmittedOnly=${this.state.unsubmittedOnly}${this.state.apptDate ? `&apptDate=${moment(this.state.apptDate).format("YYYY-MM-DD")}` : ''}`,
                null,
                true) // don't reset logout timer
            .then(d => {
                if (d && d.data) {
                    this.setState({patients: d.data});
                }
            });
        this.context.cachedGet("/lookup/location?filter=active=1%20and%20internal=1", 300)
            .then(d => {
                if (d && d.data) {
                    this.setState({locations: d.data});
                }
            });
        this.context.cachedGet("/providers/internal?active=1&users=true&roles=MD%2CMidlevel", 300)
            .then(d => {
                if (d && d.data) {
                    this.setState({internalProviders: d.data});
                }
            })


        this.refreshTimer = window.setTimeout(this.loadPatients, 5000);
    }

    setSetting = (name, value) => {
        let newState = {};
        newState[name] = value;
        // Special cases
        // submittedOnly && unsubmittedOnly are mutually exclusive
        if (name == "submittedOnly" && value) {
            newState["unsubmittedOnly"] = false;
        } else if (name == "unsubmittedOnly" && value) {
            newState["submittedOnly"] = false;
        }

        // "My Patients Only" and selected providers are mutually exclusive
        if (name == "myPatients" && value) {
            newState["selectedProviderIds"] = [];
        }
        if (name == "selectedProviderIds" && value && value.length > 0) {
            newState["myPatients"] = false;
        }

        this.setState(newState, () => {
            this.loadPatients();
            this.saveSettings();
        });
    }

    toggleProvider = (e) => {
        let providerId = parseInt(e.target.value);
        let checked = e.target.checked;
        let index = this.state.selectedProviderIds.findIndex(p => p == providerId);
        let provs = [...this.state.selectedProviderIds];
        if (checked && index == -1) {
            provs.push(providerId);
        } else if (!checked && index >= 0) {
            provs.splice(index, 1);
        }
        this.setSetting("selectedProviderIds", provs);
    }

    toggleSetting = (name) => {
        let newValue = !this.state[name];
        this.setSetting(name, newValue);
    }

    patientSelected = (patientId) => {
        this.setState({patientId: patientId}, this.loadPatients);
    }

    locationSelected = (e) => {
        this.setState({locationId: e.target.value}, () => {
            this.loadPatients();
            this.saveSettings();
        });
    }

    getFilterText = () => {
        let filters = [];
        if (this.state.apptDate) filters.push(moment(this.state.apptDate).format("M/D/YY"));
        if (this.state.myPatients) filters.push("My Pts Only");
        if (this.state.selectedProviderId > 0) {
            let prov = this.state.internalProviders.find(p => p.providerId == this.state.selectedProviderId);
            if (prov) {
                filters.push(prov.fullName);
            }
        }
        if (this.state.unsubmittedOnly) filters.push("Unsubmitted");
        if (this.state.submittedOnly) filters.push("Submitted");
        if (this.state.arrived) filters.push("Arrived Only");
        if (this.state.locations.length > 0 && this.state.locationId) filters.push("Loc: " + this.state.locations.find(l => l.locationId == this.state.locationId).addr1);
        return filters.length > 0 ? filters.join(", ") : "None";
    }

    toggleInLobby = (sbId) => {
        let pts = [...this.state.patients];
        let pt = pts.find(p => p.superbillId == sbId);
        if (pt) {
            if (pt.inLobbyAt) {
                pt.inLobbyAt = null;
            } else {
                pt.inLobbyAt = new Date();
            }
            this.setState({patients: pts});
            this.context.apiRequest("POST", `/superbill/${sbId}/toggleInLobby`);
        }
    }

    render() {
        return <Container fluid>
            <Row>
                <Col sm={12} lg={9}>
                    <Row>
                        <Col sm={"auto"} className={"align-self-center"}>
                            <Button variant={"secondary"} onClick={() => this.setState({showFilterModal: true})}
                                    className={"mr-3 ml-3"}><Glyph name={"filter"}/></Button>
                            <b>Filters:</b>
                        </Col>
                        <Col className={"align-self-center"}><small>{this.getFilterText()}</small></Col>
                        <Col sm={6} className={"text-right align-self-center mt-2"}>
                            <PatientSearch id={"superbillPtSearch"} clearOnSelect={false} showNewButton={false} showGoButton={false} patientSelected={this.patientSelected} onInputChanged={() => this.patientSelected(null)}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <ListGroup variant={"flush"} className={"mb-4"}>
                                {
                                    this.state.patients.map(p => <PatientListRow key={p.patientId+p.appointmentDate} patient={p} onToggleInLobby={this.toggleInLobby}/>)
                                }
                            </ListGroup>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Modal show={this.state.showFilterModal} size={"sm"} onHide={() => this.setState({showFilterModal: false})} centered>
                <ModalHeader closeButton>Filters</ModalHeader>
                <ModalBody>
                    { // only show checkbox if current user is a provider
                        this.context.userProfile.providerId && <Row className={"mb-3"}>
                            <Col>
                                <FormCheck inline type={"checkbox"} label={"My Patients Only"} value={this.state.myPatients} onChange={() => this.toggleSetting("myPatients")} checked={this.state.myPatients}/>
                            </Col>
                        </Row>
                    }
                    <Row className={"mb-3"}>
                        <Col>
                            <Card body>
                                <h5>Providers</h5>
                                {this.state.internalProviders.map(p => <Row key={p.providerId}>
                                    <Col>
                                        <FormCheck type={"checkbox"} value={p.providerId} label={p.fullName} checked={this.state.selectedProviderIds.includes(p.providerId)} onChange={this.toggleProvider}/>
                                    </Col>
                                </Row>)}
                            </Card>
                            {/*<OptionalSelect value={this.state.selectedProviderId} options={this.state.internalProviders} canSelectNone={true} noneValue={0} noneLabel={"All Providers"} labelKey={"fullName"} valueKey={"providerId"} onChange={e => this.setSetting("selectedProviderId", parseInt(e.target.value))}/>*/}
                        </Col>
                    </Row>
                    { // only show checkbox if current user is a provider
                        this.context.hasAnyRole(["Superbill Editor", "System Admin"]) && <>
                            <Row className={"mb-3"}>
                                <Col>
                                    <FormCheck inline type={"checkbox"} label={"Unsubmitted Only"} value={this.state.unsubmittedOnly} onChange={() => this.toggleSetting("unsubmittedOnly")} checked={this.state.unsubmittedOnly}/>
                                </Col>
                            </Row>
                            <Row className={"mb-3"}>
                                <Col>
                                    <FormCheck inline type={"checkbox"} label={"Submitted Only"} value={this.state.submittedOnly} onChange={() => this.toggleSetting("submittedOnly")} checked={this.state.submittedOnly}/>
                                </Col>
                            </Row>
                        </>
                    }
                    <Row className={"mb-3"}>
                        <Col>
                            <FormCheck inline type={"checkbox"} label={"Arrived Only"} value={this.state.arrived} onChange={() => this.toggleSetting("arrived")} checked={this.state.arrived}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <FormLabel>Location:</FormLabel>
                                <FormControl as={"select"} custom onChange={this.locationSelected} value={this.state.locationId}>
                                    <option value={""}>All locations</option>
                                    {
                                        this.state.locations && this.state.locations.map(l => <option key={l.locationId} value={l.locationId}>{l.addr1}</option>)
                                    }
                                </FormControl>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <FormLabel>Date:</FormLabel>
                                <InputGroup>
                                    <Form.Control value={this.state.apptDate ? moment(this.state.apptDate).format("M/D/YY") : "Today"} disabled/>
                                    <InputGroup.Append>
                                        <InputGroup.Text variant={"dark"}><CalendarButton selected={this.state.apptDate} onChange={(dt) => this.setSetting("apptDate", dt)}/></InputGroup.Text>
                                    </InputGroup.Append>
                                    <InputGroup.Append>
                                        <InputGroup.Text variant={"dark"}><Glyph name={"x-circle"} className={"clickable"} onClick={(dt) => this.setSetting("apptDate", null)}/></InputGroup.Text>
                                    </InputGroup.Append>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </Container>
    }
}